import React from 'react';
import _ from 'lodash';
import SimpleFormikField from 'novigo-simple-formik-field';
import PropTypes from 'prop-types';

function FormikInput(props) {
  return (
    <SimpleFormikField name={props.name} label={props.label} {...props}>
      {({
        // field, // { name, value, onChange, onBlur }
        form: { values, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
      }) => (
        <input
          onChange={
            props.onChange ||
            ((e, data) => setFieldValue(props.name, data.value))
          }
          disabled={props.disabled || false}
          value={props.initialValue || _.get(values, `${props.name}`, '')}
          placeholder={props.placeholder}
        />
      )}
    </SimpleFormikField>
  );
}

FormikInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  placeholder: PropTypes.string,
};

export default FormikInput;
